export const calcultorList = [
    {
        appliance: 'Wi-Fi router',
        watts: '10W (AC)',
        delta2: '58 hrs',
    },
    {
        appliance: 'Phone',
        watts: '11Wh (Type-C)',
        delta2: '89 times',
    },
    {
        appliance: 'Fan',
        watts: '40W (AC)',
        delta2: '17 hrs',
    },
    {
        appliance: '50" TV',
        watts: '110W (AC)',
        delta2: '7.9 hrs',
    },
    {
        appliance: 'Refrigerator',
        watts: '120W (AC)',
        delta2: '7-14hrs',
    },
    {
        appliance: 'Laptop',
        watts: '60Wh (Type-C)',
        delta2: '16 times',
    },
    {
        appliance: 'PS5',
        watts: '200W (AC)',
        delta2: '4.6 hrs',
    },
    {
        appliance: 'PC',
        watts: '500W (AC)',
        delta2: '1.8 hrs',
    },
    {
        appliance: 'Coffee maker',
        watts: '1000W (AC)',
        delta2: '0.8 hrs',
    },
    {
        appliance: 'Camera',
        watts: '16Wh (USB)',
        delta2: '60 times',
    },
    {
        appliance: 'Light',
        watts: '10W (AC)',
        delta2: '58 hrs',
    },
    {
        appliance: 'Light',
        watts: '10W (DC)',
        delta2: '98 hrs',
    },
    {
        appliance: 'Washer',
        watts: '500W (AC)',
        delta2: '1.8 hrs',
    },
    {
        appliance: 'Blender',
        watts: '500W (AC)',
        delta2: '1.8 hrs',
    },
    {
        appliance: 'Drone',
        watts: '40Wh (Type-C)',
        delta2: '25 times',
    },
    {
        appliance: 'Speaker',
        watts: '10W (AC)',
        delta2: '58 hrs',
    },
    {
        appliance: 'CPAP',
        watts: '40W (AC)',
        delta2: '17 hrs',
    },
    {
        appliance: 'Electric blanket',
        watts: '50W (AC)',
        delta2: '14 hrs',
    },
    {
        appliance: 'Mini/Car fridge',
        watts: '60W (DC)',
        delta2: '16-32hrs',
    },
    {
        appliance: 'Projector',
        watts: '65W (AC)',
        delta2: '12 hrs',
    },
    {
        appliance: 'Electric blanket',
        watts: '120W (AC)',
        delta2: '7 hrs',
    },
    {
        appliance: 'Baby food maker',
        watts: '300W (AC)',
        delta2: '3 hrs',
    },
    {
        appliance: 'Pressure cooker',
        watts: '900W (AC)',
        delta2: '1 hour',
    },
    {
        appliance: 'Rice cooker',
        watts: '1000W (AC)',
        delta2: '0.8 hour',
    },
    {
        appliance: 'Electric drill',
        watts: '1080W (AC)',
        delta2: '0.7 hrs',
    },
    {
        appliance: 'Cutting machine',
        watts: '1100W (AC)',
        delta2: '0.7 hrs',
    },
    {
        appliance: 'Electric grill',
        watts: '1150W (AC)',
        delta2: '0.7 hrs',
    },
    {
        appliance: 'Electric frying pan',
        watts: '1200W (AC)',
        delta2: '0.7 hrs',
    },
    {
        appliance: 'Electric hammer',
        watts: '1260W (AC)',
        delta2: '0.6 hrs',
    },
    {
        appliance: 'Microwave',
        watts: '1300W (AC)',
        delta2: '0.6 hrs',
    },
    {
        appliance: 'Circular Saw',
        watts: '1400W (AC)',
        delta2: '0.6 hrs',
    },
    {
        appliance: 'Air fryer',
        watts: '1500W (AC)',
        delta2: '0.5 hrs',
    },
    {
        appliance: 'Electric kettle',
        watts: '1500W (AC)',
        delta2: '0.5 hrs',
    },
    {
        appliance: 'Hair dryer',
        watts: '1600W (AC)',
        delta2: '0.5 hrs',
    },
    {
        appliance: 'Electric oven',
        watts: '1650W (AC)',
        delta2: '0.5 hrs',
    },
    {
        appliance: 'Air conditioner',
        watts: '1800W (AC)',
        delta2: '0.4 hrs',
    },
    {
        appliance: 'Induction cooker',
        watts: '1800W (AC)',
        delta2: '0.4 hrs',
    },
    {
        appliance: 'Electric heater',
        watts: '2200W (AC)',
        delta2: '0.4 hrs',
    },
];

export const powerMatchingEfficiency = (power: number) => {
    if (power > 0 && power <= 1800) {
        if (power < 100) {
            return 0.7042;
        } else if (power >= 100 && power < 200) {
            return 0.7868;
        } else if (power >= 200 && power < 300) {
            return 0.8263;
        } else if (power >= 300 && power < 400) {
            return 0.8644;
        } else if (power >= 400 && power < 600) {
            return 0.889;
        } else if (power >= 600 && power < 1000) {
            return 0.8837;
        } else if (power >= 1000 && power < 1300) {
            return 0.8882;
        } else if (power >= 1300 && power < 1400) {
            return 0.8875;
        } else if (power >= 1400 && power < 1600) {
            return 0.8869;
        } else if (power >= 1600 && power < 1700) {
            return 0.8841;
        } else if (power >= 1700 && power <= 1800) {
            return 0.8809;
        }
        return 0;
    }
    return 0;
};
